import Modal from '../modal';
import EventEmitter, { EVENT_TYPES } from '@lib/eventEmitter';

export interface EvGrantBannerProps {
  variant: 'serps' | 'product';
}

const EvGrantBanner = ({ variant }: EvGrantBannerProps) => {
  const openModal = () =>
    EventEmitter.emit(EVENT_TYPES.openModal, `ev-grant-modal`);
  const closeModal = () => EventEmitter.emit(EVENT_TYPES.closeModal);

  return (
    <>
      <div className="ac-promo ac-promo--ev-grant ac-bc--ev-dark-green ch-ba--2 ch-justify-content--between ch-align-items--start">
        <div className="ac-promo--ev-grant__heading ch-fw--600 ch-fs--3">
          <span className="ac-color--ev-dark-green">Get £750 off</span>{' '}
          {variant === 'serps'
            ? 'any used electric car or home charger!'
            : 'this car or a home charger!'}{' '}
          <button
            className="ac-promo__link ch-color--ac-black ch-fw--400 sm:ch-fs--3 ch-btn ch-btn--link ch-pa--0"
            onClick={openModal}
            type="button"
          >
            Find out more
          </button>
        </div>
        <img
          alt=""
          className="ac-promo__image ch-ml--1"
          height="32"
          width="24"
        />
      </div>
      <Modal hideClose id="ev-grant-modal">
        <div className="ch-modal ev-grant-modal">
          <div className="modal__header ev-grant-modal__header">
            <button
              className="ch-modal__close"
              onClick={closeModal}
              type="button"
            >
              <span className="ch-reader">Close</span>
            </button>
          </div>
          <div className="ch-text--center ch-pa--3 ch-bg--white">
            <p className="ch-fs--4 ch-fw--600">
              Get £750 off any used electric car or home charger.
            </p>
            <p className="ch-fs--3">
              Whether you&apos;d like to use this discount on your car or a home
              charger installed by Bumblebee, our friendly sales team will help
              you make the right choice.
            </p>
            <a
              className="ch-mb--2 ch-fs--1"
              href="/terms#ac-ev-grant"
              rel="nofollow"
            >
              Terms and conditions
            </a>
            <hr className="ch-mv--4" />
            <a
              className="ch-btn ch-btn--success ch-btn--sm ch-width--12 sl:ch-width--10 ch-mb--4"
              href="/vehicles?query=Arnold+Clark+Used+Grant"
              rel="nofollow"
            >
              Search our EV stock
            </a>
            <p className="ch-fs--3 ch-fw--500">
              Still unsure about making the switch?
            </p>
            <a
              className="ch-btn ch-btn--secondary ch-btn--sm ch-width--12 sl:ch-width--10"
              href="/electric-cars/"
              rel="nofollow"
            >
              View our electric vehicle guide
            </a>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default EvGrantBanner;
